import { Typography } from '@mui/material';
import { format } from 'date-fns';
import { PosShift } from '../../apiTypes';
import PrintModal from '../../components/PrintModal';
import { t } from '../../constants/translations';
import { useAdmin } from '../../contexts/admin.context';
import { useLocale } from '../../contexts/locale.context';
import currency from '../../utils/currency';

interface Props {
  onClose: () => void;
  shift: DbDocument<PosShift>;
}

const ShiftPrintModal = (props: Props) => {
  const { onClose, shift } = props;
  const { lang } = useLocale();
  const { cafe } = useAdmin();

  return (
    <PrintModal onClose={onClose} isPosPrinter>
      <Typography variant="h6">{t.created[lang]}:</Typography>
      <Typography>
        {shift.createdBy.name} - {format(new Date(shift.created), 'dd.MM HH:mm')}
      </Typography>

      {shift.closed && (
        <>
          <Typography variant="h6" sx={{ mt: 3 }}>
            {t.shift_closed[lang]}:
          </Typography>
          <Typography>
            {shift.closedBy?.name} - {format(new Date(shift.closed), 'dd.MM HH:mm')}
          </Typography>
        </>
      )}

      <Typography variant="h6" sx={{ mt: 3 }}>
        {t.shift_start_balance[lang]}:
      </Typography>
      {shift.startWalletState
        .filter((w) => !w.hidden)
        .map((w) => (
          <Typography key={w.id}>
            <strong>{w.name}</strong>: {currency(w.balance, cafe?.currency)}
          </Typography>
        ))}

      {shift.endWalletState?.length && (
        <>
          <Typography variant="h6" sx={{ mb: 1, mt: 3 }}>
            {t.shift_end_balance[lang]}:
          </Typography>
          {shift.endWalletState
            .filter((w) => !w.hidden)
            .map((w) => (
              <Typography key={w.id}>
                <strong>{w.name}</strong>: {currency(w.balance, cafe?.currency)}
              </Typography>
            ))}
        </>
      )}
    </PrintModal>
  );
};

export default ShiftPrintModal;
